module.exports = __webpack_public_path__ + "media/Mayorkun-Up-To-Something.b9b8782f.mp3";